import { useSelector } from 'react-redux';
import { selectEnablePromotionsVersionThree } from '../brand/ducks/selectors';
import { Promotions as PromotionsV2, PromotionsV3 } from './promotions-async';

interface Props {
	showMarketplaceTab?: boolean;
	thunderbiteTabRoute?: {
		type: string;
		payload: unknown;
	};
}

const Shop = ({ showMarketplaceTab, thunderbiteTabRoute }: Props) => {
	const enablePromotionsVersionThree = useSelector(selectEnablePromotionsVersionThree);

	return enablePromotionsVersionThree ? (
		<PromotionsV3 showMarketplaceTab={showMarketplaceTab} />
	) : (
		<PromotionsV2 showMarketplaceTab={showMarketplaceTab} thunderbiteTabRoute={thunderbiteTabRoute} />
	);
};

export default Shop;
